import React, {useCallback, useMemo} from 'react';
import {useParams} from 'react-router-dom';
import {LoadWrapper} from 'components/LoadWrapper';
import {BaselineBreadcrumbs} from '../utils/BaselineBreadcrumbs';
import {NotFoundPage} from 'components/NotFoundPage';
import {useBaselineDetailsPageTranslations} from './BaselineDetailsPage.utils';
import {useBoolean} from '@fluentui/react-hooks';
import {AttachmentRef, BooleanState} from 'types';
import {useCommand} from 'hooks';
import {BaselineDetailsSection} from '../utils/BaselineDetailsSection';
import _ from 'lodash';
import {BaselineDownloadBtn} from '../BaselineListPage/BaselineDownloadBtn';
import {v4 as uuidv4} from 'uuid';
import {BaselineDetailsPageParams} from './BaselineDetailsPage.types';
import {useGetVehicleProjectDetailsQuery} from '../../VehicleProjects/hooks';
import BaselineDetailsTabRequirements from '../../VehicleProjects/AssignedEntities/BaseLineDetailsTabRequirements';
import {useGetBaselineByIdQuery} from '../hooks/baseline.generated';
import {BaselinesSelectionDialog} from '../BaselineComparisonPage/BaselinesSelectionDialog/BaselinesSelectionDialog';
import {PossibleSelectedBaseline} from '../BaselineComparisonPage/BaselinesSelectionDialog/BaselinesSelectionDialog.types';
import {VehicleProjectDetailsSection} from 'features/VehicleProjects';

const emptyArray: never[] = [];

export function BaselineDetailsPage() {
	const params = useParams() as unknown as BaselineDetailsPageParams;
	const {t} = useBaselineDetailsPageTranslations();

	const {data, loading} = useGetBaselineByIdQuery({
		variables: {id: params.id ?? ''},
	});

	const {data: dataVehPro} = useGetVehicleProjectDetailsQuery({
		variables: {
			generation: params.generation ?? '',
			modelSeries: params.modelSeries ?? '',
		},
	});

	const baseline = data?.baselineById;

	if (loading) return <LoadWrapper loading={loading} />;
	if (!baseline) return <NotFoundPage />;

	const {name} = baseline;

	return (
		<>
			<BaselineBreadcrumbs baselineName={name} params={params} />
			<VehicleProjectDetailsSection dataVehPro={dataVehPro} />
			<BaselineDetailsTabRequirements dataVehPro={dataVehPro} hidden={false} />
			<BaselinesSelectionDialog
				params={params}
				baseline1Initial={baseline as PossibleSelectedBaseline}
			/>
		</>
	);
}
